module.exports = __webpack_public_path__ + "img/teacher-explain.950810e0.jpg";